var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "resizable",
      style: { width: _vm.width + "mm", height: _vm.height + "mm" },
    },
    [
      _vm._t("default"),
      _c(
        "div",
        {
          staticClass: "anchor",
          on: {
            mousedown: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onMouseDown.apply(null, arguments)
            },
          },
        },
        [_c("w-fa", { attrs: { icon: "expand-arrows-alt" } })],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }